import { isEmpty } from '../external/utilities/GeneralUtils'

export function displayBasicFacilityDetails(contractConfig, facility = null) {
  if (isEmpty(contractConfig)) {
    return false
  }

  let basic = false
  if (contractConfig.listingOnlyContract) {
    basic = true
  } else if (!isEmpty(facility) && facility.nonClientFacility) {
    basic = true
  }

  return basic
}

export function getBulletinCount(facility) {
  return isEmpty(facility) || isEmpty(facility.bulletins)
    ? 0
    : facility.bulletins.length
}

export function getContractNoteCount(contractConfig) {
  return isEmpty(contractConfig) || isEmpty(contractConfig.contractNotes)
    ? 0
    : 1
}

export function getTotalContractNotesAndBulletins(facility, contractConfig) {
  return getBulletinCount(facility) + getContractNoteCount(contractConfig)
}

export function isContractProductNotificationAllowed(contractConfig) {
  let allowed = false
  if (!isEmpty(contractConfig)) {
    if (contractConfig.supportsAvailabNotif) {
      allowed = true
    }
  }

  return allowed
}
